import clx from 'classnames';
import { useEffect, useState } from 'react';
import './index.css';
type IProps = React.PropsWithChildren<{
  container: HTMLElement | null;
  visible?: boolean;
  onClose?: () => void;
}>;
const CustomDropdown = ({ container, children, visible, onClose }: IProps) => {
  const [top, setTop] = useState<number>(0);
  useEffect(() => {
    const rect = container?.getBoundingClientRect();
    const bottomRelativeToViewport = rect?.bottom;
    setTop(bottomRelativeToViewport || 0);
  }, [container]);
  return (
    <div
      className={clx('custom-popup', { 'custom-popup--visible': visible })}
      style={{ top }}
    >
      <div className="custom-popup__overlay" onClick={onClose} />
      <div className="custom-popup__container">{children}</div>
    </div>
  );
};

export default CustomDropdown;
